import DashboardComponent from "./Dashboard";

export default DashboardComponent;
